// JAWS vs VoiceOver (see doc/jaws-voiceover-accessibility-reference.md):
// aria-pressed is announced by JAWS on activation; decorative SVG icons are hidden
// so JAWS does not read raw path data from icon markup.

import React from 'react'
import { Check } from '@mui/icons-material'

const InterestCard = ({ title, onClick, active, children }) => {
  // CTS-9218 — YNS-019: native button, aria-pressed, Check icon + ring/focus-visible so selection is not color-only and is keyboard-operable.
  const extraClasses = active
    ? 'text-[#fff] bg-primary border-primary ring-2 ring-primary ring-offset-2'
    : ''
  const hoverTextClass = !active ? 'hover:text-[#2F2F2F]' : ''
  const hoverBgClass = !active ? 'hover:bg-intoo-blue-light' : ''

  return (
    <button
      type="button"
      data-testid="a11y-onboarding--interest-card"
      className={`w-fit border-0 bg-transparent p-0 text-left text-[#2F2F2F] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ${hoverTextClass}`}
      onClick={onClick}
      aria-pressed={active}
    >
      <div
        className={`aspect-square relative mx-auto flex h-28 w-28 flex-col items-center justify-evenly rounded-[20px] border-2 border-solid border-[#B9B9B9] px-2 py-3 text-center text-sm shadow-[0_2px_4px_0px_rgba(0,0,0,0.15)] md:h-40 md:w-40 md:text-lg ${extraClasses} ${hoverBgClass}`}
      >
        {active && (
          <span
            className="absolute right-1 top-1 flex text-[#fff]"
            aria-hidden="true"
          >
            <Check className="h-[18px] w-[18px] md:h-[22px] md:w-[22px]" />
          </span>
        )}
        <span aria-hidden="true">{children}</span>
        <div>{title}</div>
      </div>
    </button>
  )
}
export default InterestCard
